import Vue from "vue";
import api from "@/api/movimentos.js";

const createExclusaoSolicBeneficiarioRascunho = params => {
  return Vue.api
    .post(api.exclusaoSolicBeneficiarioRascunho, {
      codigoBeneficiario: params.beneficiarioCartao,
      beneficiarioSelecionadoRequests: params.beneficiarioSelecionadoRequests,
      tipoAtendimentoId: 1,
      sistemaIntegracaoId: 2,
      usuarioId: params.usuarioId
    })
    .then(({ data }) => data);
};

const segundaViaCriarRascunho = params => {
  return Vue.api
    .post(api.segundaViaCriarRascunho(), {
      motivoSegundaViaId: params.motivoSegundaViaId,
      codigoBeneficiario: params.codigoBeneficiario,
      prioridade: 0,
      tipoAtendimentoId: 1,
      sistemaIntegracaoId: 2,
      justificativa: params.justificativa,
      usuarioId: params.usuarioId
    })
    .then(({ data }) => data);
};

const createMovimentoAlteracao = (tipo, params) => {
  return Vue.api
    .post(api.movimentoAlteracao(tipo), {
      codigoBeneficiario: params.beneficiarioCartao,
      codigoEmpresa: params.codigoEmpresa,
      codigoContrato: params.codigoContrato,
      codigoTitular: params.codigoTitular,
      codigoGrauDependencia: params.codigoGrauDependencia,
      prioridade: 0,
      tipoAtendimentoId: 1,
      sistemaIntegracaoId: 2,
      usuarioId: params.usuarioId
    })
    .then(response => response.data);
};

const cancelarMovimento = movimentoId => {
  return Vue.api.post(api.cancelarMovimento(movimentoId));
};

const cancelarMovimentos = movimentosId => {
  return Vue.api.post(api.cancelarMovimentos(), movimentosId);
};

const enviarMovimentoParaAuditoria = movimentoId => {
  return Vue.api.post(api.enviarMovimentoParaAuditoria(movimentoId));
};

const enviarMovimentoParaAuditoriaQueue = movimentoId => {
  return Vue.api.post(api.enviarMovimentoParaAuditoriaQueue(movimentoId));
};

const exclusaoPrepararEnvio = movimentoId => {
  return Vue.api.post(
    api.movimentoPrepararEnvio(
      "exclusoes_solicitadas_beneficiario",
      movimentoId
    )
  );
};

const getBeneficiario = codigoBeneficiario => {
  const query = `{
    beneficiario(codigoBeneficiario: "${codigoBeneficiario}") {
      codigoBeneficiario
      nomeBeneficiario
      nomeMae
      ativo
      faturaContra
      permiteExclusaoPlano
      localAtendimento {
        unimedId
      }
      tipoColaborador {
        id
        descricao
        tipoColaboradorId
      }
      grauDependencia {
        grauDependenciaId
      }
      centroCusto {
        centroCustoId
      }
      dataExclusao
      empresa {
        id
      }
      titularId
      pessoaId
      dataNascimento
      cpf
      contrato {
        id
        contratoId
        codigoPlanoAns
        ativo
        planoNomeComercial
        planoColetivoAdesao
        planoColetivoEmpresarial
        planoIndividualFamiliar
      }
    }
  }`;

  return Vue.api.graphql(api.graphql, query).then(({ data }) => data);
};

const getCartaoFrente = beneficiarioCartao => {
  return Vue.api
    .get(api.getCartao("frente", beneficiarioCartao))
    .then(response => response.data);
};

const getCartaoVerso = beneficiarioCartao => {
  return Vue.api
    .get(api.getCartao("verso", beneficiarioCartao))
    .then(response => response.data);
};

const getCodigosBancos = () => {
  return Vue.api.get(api.getCodigosBancos).then(({ data }) => data);
};

const getDadosBancariosExclusao = beneficiarioCartao => {
  return Vue.api
    .get(api.getDadosBancariosExclusao(beneficiarioCartao))
    .then(response => response.data);
};

const getDadosPessoais = pessoaId => {
  const query = `{
    dadosPessoais(pessoaId: "${pessoaId}") {
      nome
      nomeMae
      nomePai
      dataNascimento
      cpf
      rgNumero
      rgDataExpedicao
      rgUfEmissor
    }
  }`;

  return Vue.api.graphql(api.graphql, query).then(({ data }) => data);
};

const getEnderecosFinalidade = (ativo = null) => {
  const query = `{
    enderecosFinalidade(ativo: ${ativo}) {
      id
      descricao
    }
  }`;

  return Vue.api
    .graphql(api.graphql, query)
    .then(response => response.data?.data?.enderecosFinalidade);
};

const getExclusoesSolicitadasBeneficiario = movimentoId => {
  const query = `{
    exclusoesSolicitadasBeneficiario(
      id: ${movimentoId}, page: 0, size: 10
    ) {
      content {
        id
        dataCriacao
        codigoBeneficiario
        numeroCartao
        nomeBeneficiario
        tipoEnvioComunicado
        atendimento {
          tipoAtendimento {
            id
            descricao
          }
        }
        exclusaoBeneficiarioSelecionados {
          beneficiario
          numeroCartao
          dataObito
          motivoExclusao {
            id
            descricao
          }
          id
          motivoObito {
            descricao
          }
          nomeBeneficiario
        }
        movimentoEndereco {
          id
          cep
          logradouro
          numero
          bairro
          cep
        }
        movimentoContatos {
          id
          contato
          tipoContato {
            id
            descricao
          }
        }
        codigoBeneficiario
        codigoContrato
        descricaoContrato
        codigoEmpresa
        codigoGrauDependencia
        dataConclusao
        dataCriacao
        dataExclusao
        dataSolicitacao
        observacoesSolicitante
        statusMovimento {
          id
          descricao
        }
        tipoMovimento {
          id
          descricao
        }
        solicitouExclusaoRh
        dataSolicitacaoRh
        nomePessoaSolicExclusao
      }
    }
  }`;

  return Vue.api.graphql(api.graphql, query).then(({ data }) => data);
};

const getFamiliaBeneficiarioParaExclusao = codigoBeneficiario => {
  return Vue.api
    .get(api.getFamiliaBeneficiarioParaExclusao(codigoBeneficiario))
    .then(({ data }) => data)
    .catch(({ response }) => response);
};

const getFamiliaCompleta = pessoaId => {
  return Vue.api
    .get(api.getFamiliaCompleta(pessoaId))
    .then(({ data }) => data)
    .catch(({ response }) => response);
};

const getInclusaoAlteracaoBeneficiario = movimentoId => {
  const query = `{
    inclusaoAlteracaoBeneficiario(id: ${movimentoId}) {
      id
      movimento {
        id
        dataCriacao
        statusMovimento {
          id
          descricao
        }
      }
      beneficiario
      numeroCartao
      dataInicioVigencia
      nome
      nomeMae
      dataNascimento
      observacoesSolicitante
      movimentoEnderecos {
        id
        cep
        logradouro
        numero
        bairro
        cidade
        uf
        complemento
        pontoReferencia
        caixaPostal
        tipoEndereco {
          id
          descricao
        }
        enderecoFinalidades {
          id
        }
      }
      movimentoContatos {
        id
        contato
        tipoContato {
          id
          descricao
        }
      }
    }
  }`;

  return Vue.api.graphql(api.graphql, query).then(({ data }) => data);
};

const getLogoCartao = () => {
  return Vue.api
    .get(api.getLogoCartao, {
      responseType: "blob"
    })
    .then(response => response.data);
};

const getMotivosExclusao = (dependente = false) => {
  return Vue.api.get(api.motivosExclusao(dependente)).then(({ data }) => data);
};

const getMotivosObito = () => {
  const query = `{
    motivosObito {
      id
      descricao
    }
  }`;

  return Vue.api.graphql(api.graphql, query).then(({ data }) => data);
};

const listarMotivosSegundaVia = () => {
  const query = `{
    listarMotivosSegundaVia {
      id
      descricao
    }
  }`;

  return Vue.api
    .graphql(api.graphql, query)
    .then(response => response.data?.data?.listarMotivosSegundaVia);
};

const listarMovimentoAnexos = movimentoId => {
  const query = `{
    listarMovimentoAnexos(movimentoId: ${movimentoId}) {
        id
        tipoAnexo {
          id
          descricao
        }
        anexo {
          id
          filename
          path
          arquivoId
        }
      }
    }`;

  return Vue.api
    .graphql(api.graphql, query)
    .then(response => response.data?.data?.listarMovimentoAnexos);
};

const getMovimento = movimentoId => {
  const query = `{
    movimento(id: ${movimentoId}) {
      id
      observacoesSolicitante
      statusMovimento {
        id
        descricao
      }
      dataCriacao
    }
  }`;

  return Vue.api
    .graphql(api.graphql, query)
    .then(response => response.data?.data?.movimento);
};

const getMovimentosBeneficiario = (
  codigoBeneficiario,
  tipoMovimento,
  statusMovimento,
  dataCriacaoInicio,
  dataCriacaoFim,
  page,
  size,
  order
) => {
  let filter = "sistemaIntegracaoId: 2,";
  filter += codigoBeneficiario
    ? `codigoBeneficiario: "${codigoBeneficiario}",`
    : "";
  filter += statusMovimento ? `statusMovimento: ${statusMovimento},` : "";
  filter += tipoMovimento ? `tiposMovimento: ${tipoMovimento},` : "";
  filter += dataCriacaoInicio
    ? `dataCriacaoInicio: "${dataCriacaoInicio}",`
    : "";
  filter += dataCriacaoFim ? `dataCriacaoFim: "${dataCriacaoFim}",` : "";
  filter += `page: ${page},`;
  filter += `size: ${size},`;
  filter += `sort: "${order}",`;

  const query = `{
    findMovimentosBeneficiario(${filter}) {
      content {
        id
        statusMovimento {
          id
          descricao
        }
        atendimento {
          id
          protocolo
        }
        tipoMovimento {
          id
          descricao
        }
        movimentoOrigem {
          id
        }
        sistemaIntegracao {
          id
          descricao
        }
        dataConclusao
        dataCriacao
        prioridade
        codigoBeneficiario
      }
      totalElements
    }
  }`;

  return Vue.api
    .graphql(api.graphql, query)
    .then(response =>
      codigoBeneficiario !== null && codigoBeneficiario !== ""
        ? response.data?.data?.findMovimentosBeneficiario
        : []
    );
};

const getMovimentosDuplicados = ({
  codigoBeneficiario = "",
  tipoMovimentoId = "",
  cpf = "",
  nomeBeneficiario = "",
  nomeMae = "",
  dataNascimento = "",
  sexoId = "",
  sistemaIntegracaoId = 2,
  codigoEmpresa = ""
}) =>
  Vue.api
    .get(
      api.movimentosDuplicados({
        codigoBeneficiario: codigoBeneficiario,
        tipoMovimentoId: tipoMovimentoId,
        cpf: cpf,
        nomeBeneficiario: nomeBeneficiario,
        nomeMae: nomeMae,
        dataNascimento: dataNascimento,
        sexoId: sexoId,
        sistemaIntegracaoId: sistemaIntegracaoId,
        codigoEmpresa: codigoEmpresa
      })
    )
    .then(({ data }) => data)
    .catch(({ response }) => response);

const getParametroEfetivacaoAutomatica = parametroId => {
  const query = `{
    parametroMovimentacao(id:${parametroId}) {
      parametroValores {
        valor
        dataInativacao
      }
    }
  }`;

  return Vue.api
    .graphql(api.graphql, query)
    .then(
      response => response.data?.data?.parametroMovimentacao?.parametroValores
    );
};

const getPessoaEnderecos = pessoaId => {
  const query = `{
    pessoaEnderecos(pessoaId: "${pessoaId}") {
      cep
      logradouro
      numero
      bairro
      cidade
      uf
      complemento
      pontoReferencia
      caixaPostal
      tipoEndereco {
        id
        descricao
      }
      enderecoFinalidades {
        id
      }
    }
  }`;

  return Vue.api.graphql(api.graphql, query).then(({ data }) => data);
};

const getPessoaContatos = pessoaId => {
  const query = `{
    pessoaContatos(pessoaId: "${pessoaId}", tipoEnderecoId: "1") {
      id
      contato
    }
  }`;

  return Vue.api.graphql(api.graphql, query).then(({ data }) => data);
};

const getSegundaViaCartao = movimentoId => {
  const query = `{
    segundaViaCartao(id: ${movimentoId}) {
      codigoBeneficiario
      motivoSegundaVia {
        id
        descricao
      }
      justificativa
    }
  }`;

  return Vue.api.graphql(api.graphql, query).then(({ data }) => data);
};

const getStatusMovimentos = () => {
  const query = `{
    statusMovimentos {
      id
      descricao
    }
  }`;

  return Vue.api
    .graphql(api.graphql, query)
    .then(response => response.data?.data?.statusMovimentos);
};

const listarTiposAnexo = () => {
  const query = `{
    listarTiposAnexo {
      id
      descricao
    }
  }`;

  return Vue.api
    .graphql(api.graphql, query)
    .then(response => response.data?.data?.listarTiposAnexo);
};

const getTiposEnderecos = (ativo = null) => {
  const query = `{
    tiposEnderecos(ativo: ${ativo}) {
      id
      descricao
    }
  }`;

  return Vue.api
    .graphql(api.graphql, query)
    .then(response => response.data?.data?.tiposEnderecos);
};

const getTiposMovimentos = () => {
  const query = `{
    tiposMovimentos {
      id
      descricao
    }
  }`;

  return Vue.api
    .graphql(api.graphql, query)
    .then(response => response.data?.data?.tiposMovimentos);
};

const downloadAnexoMovimento = movimentoArquivoId => {
  return Vue.api
    .get(api.downloadAnexoMovimento(movimentoArquivoId))
    .then(response => response)
    .catch(({ response }) => response);
};

const removerAnexo = movimentoArquivoId => {
  return Vue.api.delete(api.removerAnexo(movimentoArquivoId));
};

const saveExclusaoSolicBeneficiario = (movimentoId, movimento) => {
  return Vue.api.patch(
    api.saveExclusaoSolicBeneficiario(movimentoId),
    movimento
  );
};

const segundaViaPrepararEnvio = movimentoId => {
  return Vue.api.post(
    api.movimentoPrepararEnvio("segunda_via_cartoes", movimentoId)
  );
};

const updateMovimentoAlteracao = params => {
  return Vue.api
    .patch(api.updateMovimentoAlteracao(), {
      id: params.id,
      codigoAgrupamento: params.agrupamento?.empresaId
        ? params.agrupamento.empresaId
        : null,
      codigoBeneficiario: params.beneficiario,
      codigoCentroCusto: params.centroCusto?.centroCustoId,
      codigoContrato: params.codigoContrato,
      dataAdmissao: params.dataAdmissao,
      dataAdocao: params.dataAdocao,
      dataInicioVigencia: params.dataInicioVigencia,
      dataNascimento: params.dataNascimento,
      dataSolicitacaoInclusao: params.dataSolicitacaoInclusao,
      dataExclusaoPlanoAnterior: params.dataExclusaoPlanoAnterior,
      diaVencimento: params.diaVencimento,
      codigoBeneficiarioPlanoAnterior: params.codigoBeneficiarioPlanoAnterior,
      codigoEmpresa: params.empresa?.id,
      estadoCivil: params.estadoCivil,
      codigoGrauDependencia: params.grauDependencia?.grauDependenciaId,
      codigoLocalAtendimento: params.localAtendimento?.unimedId,
      matriculaColaborador: params.matriculaColaborador,
      nomeBeneficiario: params.nomeBeneficiario,
      nomeMae: params.nomeMae,
      nomePai: params.nomePai,
      nomeSocial: params.nomeSocial,
      generoSocial: params.generoSocial,
      pais: params.pais?.id,
      sexo: params.sexo,
      tipoColaborador: params.tipoColaborador?.tipoColaboradorId,
      vinculoAposInclusaoTitular: params.vinculoAposInclusaoTitular,
      tipoPlano: params.tipoPlano,
      titular: params.titular,
      titularMovimento: params.titularMovimento,
      sistemaIntegracaoId: 2,
      codigoCidadeNaturalidade: params.codigoCidadeNaturalidade,
      necessidadeDeclaracaoSaude: params.necessidadeDeclaracaoSaude,
      portabilidade: params.portabilidade,
      novasCoberturas: params.novasCoberturas,
      carenciasCumpridas: params.carenciasCumpridas,
      portabilidadeAns: params.portabilidadeAns,
      moraComTitular: params.moraComTitular,
      planoAnteriorUnimed: params.planoAnteriorUnimed,
      movimento: params.movimento,
      tipoRecebimentoBoleto: params.tipoRecebimentoBoleto
    })
    .then(({ data }) => data);
};

const cadastrarAnexo = (tipoAnexoId, movimentoId, arquivo) => {
  return Vue.api.post(api.cadastrarAnexo(tipoAnexoId, movimentoId), arquivo);
};

const getNivelEnderecoBeneficiario = () =>
  Vue.api
    .get(api.nivelEnderecoBeneficiario)
    .then(response => response.data)
    .catch(() => {
      Vue.toast.error("Erro ao carregar o parâmetro de nível do endereço");
    });

const getEnderecoBeneficiario = (pessoaId, codigoBeneficiario) => {
  return Vue.api
    .get(api.enderecoBeneficiario(codigoBeneficiario, pessoaId))
    .catch(({ response }) => response);
};

const benefTemMovInclusaoAlteracaoAberto = (
  codigoBeneficiario,
  codigoBeneficiarioTitular,
  movimentoId = null
) => {
  return Vue.api
    .get(
      api.benefTemMovInclusaoAlteracaoAberto(
        codigoBeneficiario,
        codigoBeneficiarioTitular,
        movimentoId
      )
    )
    .then(({ data }) => data)
    .catch(() => false);
};

export {
  createExclusaoSolicBeneficiarioRascunho,
  createMovimentoAlteracao,
  cancelarMovimento,
  cancelarMovimentos,
  segundaViaCriarRascunho,
  enviarMovimentoParaAuditoria,
  enviarMovimentoParaAuditoriaQueue,
  exclusaoPrepararEnvio,
  getBeneficiario,
  getCartaoFrente,
  getCartaoVerso,
  getCodigosBancos,
  getDadosBancariosExclusao,
  getDadosPessoais,
  getEnderecosFinalidade,
  getExclusoesSolicitadasBeneficiario,
  getFamiliaCompleta,
  getInclusaoAlteracaoBeneficiario,
  getLogoCartao,
  getMotivosExclusao,
  listarMotivosSegundaVia,
  getMotivosObito,
  getMovimento,
  listarMovimentoAnexos,
  getMovimentosBeneficiario,
  getMovimentosDuplicados,
  getParametroEfetivacaoAutomatica,
  getPessoaEnderecos,
  getPessoaContatos,
  getSegundaViaCartao,
  getStatusMovimentos,
  listarTiposAnexo,
  getTiposEnderecos,
  getTiposMovimentos,
  cadastrarAnexo,
  saveExclusaoSolicBeneficiario,
  segundaViaPrepararEnvio,
  updateMovimentoAlteracao,
  downloadAnexoMovimento,
  removerAnexo,
  getNivelEnderecoBeneficiario,
  getEnderecoBeneficiario,
  getFamiliaBeneficiarioParaExclusao,
  benefTemMovInclusaoAlteracaoAberto
};
